import type { DirectiveFunction } from 'vue';
import DOMPurify from 'isomorphic-dompurify';

export const purify: DirectiveFunction = (el, { value }) => {
  el.innerHTML = DOMPurify.sanitize(value, {
    FORBID_TAGS: ['pre'],
    FORBID_ATTR: ['width'],
  });
};
